import { useEffect, useRef, useState } from "react";

export function useNotificationsStream(wsRef, { userId, max = 50 } = {}) {
  const [newNotifications, setNewNotifications] = useState([]);
  const subscribedRef = useRef(false);

  // subscribe once the socket opens (and userId is known)
  useEffect(() => {
    const ws = wsRef.current;
    if (!ws || ws.readyState !== WebSocket.OPEN || !userId) return;

    if (!subscribedRef.current) {
      ws.send(JSON.stringify({ type: "subscribe", topic: `notifications.${userId}` }));
      subscribedRef.current = true;
    }
  }, [wsRef, userId]);

  // listen for messages and capture notification frames
  useEffect(() => {
    const ws = wsRef.current;
    if (!ws) return;

    const onMessage = (evt) => {
      // always log raw while debugging
      let msg;
      try {
        msg = JSON.parse(evt.data);
      } catch {
        return;
      }

      if (msg.type === "notification") {
        setNewNotifications((prev) => [msg.payload, ...prev].slice(0, max));
      }
    };

    ws.addEventListener("message", onMessage);
    return () => ws.removeEventListener("message", onMessage);
  }, [wsRef, max]);

  // helper to clear / mark read if you want
  const clear = () => setNewNotifications([]);

  return { newNotifications, clear };
}
